import { leagueFetch } from "@leagueplatform/league-fetch";
import { API_PATHS } from "common/constants/api";
import { PatchCommunicationPreferencesRequest } from "types/types";

export const patchCommunicationPreferences = async (
  values: PatchCommunicationPreferencesRequest
) => {
  const response = await leagueFetch(API_PATHS.COMMUNICATION_PREFERENCES, {
    method: "PATCH",
    body: JSON.stringify(values),
  });
  if (!response?.ok) {
    throw new Error(
      `Error Response Code ${response?.status}: ${await response.text()}`
    );
  }
};
